// extracted by mini-css-extract-plugin
export default {"header":"_3_Rp4B","voucherBanner":"bXT56N","content":"DbhtAC"};